import { pxToRem } from '@/theme/typography';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import ImageBoxFuture from '../shared/image-box-future';
import { useDialog } from '@/logic/state';
import shallow from 'zustand/shallow';

const LogoutTimerDialog: FC = () => {
  const theme = useTheme();
  const setDialog = useDialog(s => s.setDialog, shallow);

  return (
    <>
      <DialogTitle></DialogTitle>

      <DialogContent>
        <Stack
          sx={{
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <Box sx={{ marginBlock: 4 }}>
            <ImageBoxFuture
              img='/icons/booking/session-expired-icon.svg'
              title='logout'
              objectFit='contain'
              sx={{
                width: '108px',
                height: '102px',
              }}
            />
          </Box>
          <Typography
            sx={{
              color: theme.palette.grey[90],
              fontSize: pxToRem(22),
              fontWeight: 700,
              lineHeight: '33px',
              marginBottom: pxToRem(24),
            }}
          >
            <FormattedMessage id='global.session_expired' />
          </Typography>
          <Typography
            sx={{
              color: theme.palette.grey[70],
              fontSize: pxToRem(18),
              fontWeight: 400,
              lineHeight: '27px',
              textAlign: 'center',
            }}
          >
            <FormattedMessage id='logout.timer.desc' />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          id={`logout-okay`}
          variant='contained'
          fullWidth
          onClick={() => {
            setDialog({
              wrapper: false,
              isLogoutTimerDialog: false,
            });
          }}
          sx={{ height: { tablet: pxToRem(56), mobile: '56px' } }}
        >
          <FormattedMessage id='global.okay' />
        </Button>
      </DialogActions>
    </>
  );
};

export default LogoutTimerDialog;
